var map = {
	"./aboutimage.jpg": 482,
	"./course1.jpg": 610,
	"./course2.jpg": 565,
	"./course3.jpg": 0,
	"./course4.jpg": 307,
	"./homeBackground.jpg": 805,
	"./homeBackground2.jpg": 424,
	"./logo.png": 489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 530;